import React, { useState, useEffect } from 'react'
import { useParams, Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { toast } from 'react-toastify'
import { PulseLoader } from 'react-spinners'

const API_URL = process.env.REACT_APP_API_URL

const PaymentTrackerView = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [payment, setPayment] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    fetchPayment()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  // Format date to IST with AM/PM
  const formatDateToIST = (dateString) => {
    if (!dateString) return '-'
    const date = new Date(dateString)
    return date.toLocaleString('en-GB', {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    })
  }

  // Format date only (no time)
  const formatDate = (dateString) => {
    if (!dateString) return '-'
    const date = new Date(dateString)
    return date.toLocaleDateString('en-GB', {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    })
  }

  const fetchPayment = async () => {
    if (!id) {
      toast.error("Payment ID is missing", { autoClose: 2000 })
      navigate('/paymentTracker')
      return
    }

    setIsLoading(true)
    try {
      const payload = {
        action: "get-payment-by-id",
        id: id
      }

      const response = await axios.post(API_URL, payload)
      let responseData = response.data

      if (typeof responseData === 'string') {
        try {
          responseData = JSON.parse(responseData)
        } catch (parseError) {
          responseData = response.data
        }
      }

      if (responseData.success === true && responseData.data) {
        setPayment(responseData.data)
      } else {
        toast.error(responseData.message || "Failed to fetch payment details", { autoClose: 2000 })
        navigate('/paymentTracker')
      }
    } catch (error) {
      console.error("Fetch payment error:", error)
      if (error.response && error.response.data) {
        let errorData = error.response.data
        if (typeof errorData === 'string') {
          try {
            errorData = JSON.parse(errorData)
          } catch (e) {
            // Use error message as is
          }
        }
        toast.error(errorData.message || "An error occurred while fetching payment details", { autoClose: 2000 })
      } else {
        toast.error("Network error. Please check your connection and try again.", { autoClose: 2000 })
      }
      navigate('/paymentTracker')
    } finally {
      setIsLoading(false)
    }
  }

  if (isLoading) {
    return (
      <div>
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2 align-items-center">
              <div className="col-6 col-sm-6">
                <h1 className="m-0 txt_lft">View Payment</h1>
              </div>
              <div className="col-6 col-sm-6">
                <ol className="breadcrumb justify-content-end">
                  <li className="breadcrumb-item">
                    <Link to="/paymentTracker"><i className="fa-solid fa-arrow-left-long" /> Back</Link>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="frmwdth_cntr">
                <div className="col-lg-12">
                  <div className="card card-primary card-outline">
                    <div className="card-body text-center py-5">
                      <PulseLoader color="#1199B2" size={10} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  if (!payment) {
    return (
      <div>
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2 align-items-center">
              <div className="col-6 col-sm-6">
                <h1 className="m-0 txt_lft">View Payment</h1>
              </div>
              <div className="col-6 col-sm-6">
                <ol className="breadcrumb justify-content-end">
                  <li className="breadcrumb-item">
                    <Link to="/paymentTracker"><i className="fa-solid fa-arrow-left-long" /> Back</Link>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="frmwdth_cntr">
                <div className="col-lg-12">
                  <div className="card card-primary card-outline">
                    <div className="card-body text-center py-5">
                      <p>Payment not found</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2 align-items-center">
            <div className="col-6 col-sm-6">
              <h1 className="m-0 txt_lft">View Payment</h1>
            </div>
            <div className="col-6 col-sm-6">
              <ol className="breadcrumb justify-content-end">
                <li className="breadcrumb-item">
                  <Link to="/paymentTracker"><i className="fa-solid fa-arrow-left-long" /> Back</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="frmwdth_cntr">
              <div className="col-lg-12">
                <div className="card card-primary card-outline">
                  <form className="form-horizontal">
                    <div className="card-body">
                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">Supplier Name</label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            {payment.supplierId?.clientname || payment.supplierName || '-'}
                          </div>
                        </div>
                      </div>

                      {/* {payment.supplierId?.email && (
                        <div className="form-group row align-items-center">
                          <label className="col-12 col-md-4 col-form-label">Supplier Email</label>
                          <div className="col-12 col-md-8">
                            <div className="txtdsply">{payment.supplierId.email}</div>
                          </div>
                        </div>
                      )}

                      {payment.supplierId?.phonenumber && (
                        <div className="form-group row align-items-center">
                          <label className="col-12 col-md-4 col-form-label">Supplier Phone</label>
                          <div className="col-12 col-md-8">
                            <div className="txtdsply">{payment.supplierId.phonenumber}</div>
                          </div>
                        </div>
                      )} */}

                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">Beneficiary Account Number</label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">{payment.beneficiaryAccountNumber || '-'}</div>
                        </div>
                      </div>

                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">Beneficiary IFSC Number</label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">{payment.beneficiaryIfscNumber || '-'}</div>
                        </div>
                      </div>

                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">Amount</label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            {payment.amount != null ? `₹ ${payment.amount.toLocaleString()}` : '-'}
                          </div>
                        </div>
                      </div>

                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">Payment Reference</label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">{payment.debit || '-'}</div>
                        </div>
                      </div>

                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">Client Reference</label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">{payment.credit || '-'}</div>
                        </div>
                      </div>

                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">Request Status</label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            <span className="badge badge-info" style={{ fontSize: '90%', fontWeight: 550 }}>
                              {payment.requestStatus || '-'}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">Payment Date</label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">{formatDate(payment.paymentDate)}</div>
                        </div>
                      </div>

                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">Payment Status</label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            <span 
                              className={`badge ${
                                payment.paymentStatus === 'Paid' ? 'badge-success' : 
                                payment.paymentStatus === 'Pending' ? 'badge-warning' : 
                                payment.paymentStatus === 'Cancelled' ? 'badge-danger' : 
                                'badge-secondary'
                              }`}
                              style={{ fontSize: '90%', fontWeight: 550 }}
                            >
                              {payment.paymentStatus || 'Pending'}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">Status</label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            <span 
                              className={`badge ${payment.status === 'active' ? 'badge-success' : 'badge-danger'}`}
                              style={{ fontSize: '90%', fontWeight: 550 }}
                            >
                              {payment.status || '-'}
                            </span>
                          </div>
                        </div>
                      </div> */}

                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">Created By</label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            {payment.createdBy?.name || '-'}
                            {payment.createdBy?.email && (
                              <span className="text-muted small d-block">{payment.createdBy.email}</span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">Created On</label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            {formatDateToIST(payment.createdAt)}
                          </div>
                        </div>
                      </div>

                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">Updated By</label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            {payment.updatedBy?.name || '-'}
                            {payment.updatedBy?.email && (
                              <span className="text-muted small d-block">{payment.updatedBy.email}</span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="form-group row align-items-center">
                        <label className="col-12 col-md-4 col-form-label">Updated On</label>
                        <div className="col-12 col-md-8">
                          <div className="txtdsply">
                            {formatDateToIST(payment.updatedAt)}
                          </div>
                        </div>
                      </div>

                      
                    </div>

                    <div className="card-footer text-center">
                      <Link to={`/paymentTrackerEdit/${payment._id}`} className="btn btn-blue mr-2">Edit</Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaymentTrackerView